import React from 'react';

export default function EdgeInactive({
  width = 88,
  height = 88,
}: {
  width?: number,
  height?: number,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="#F0F1F2"
        d="M74.996 62.804a28.194 28.194 0 01-3.17 1.417 30.636 30.636 0 01-10.797 1.943c-14.231 0-26.628-9.79-26.628-22.352a9.469 9.469 0 014.941-8.213c-12.872.541-16.18 13.954-16.18 21.813 0 22.22 20.478 24.472 24.89 24.472 2.379 0 5.967-.692 8.12-1.372l.394-.132a38.598 38.598 0 0020.03-15.88 1.203 1.203 0 00-1.6-1.696z"
        opacity="0.35"
      />
      <path
        fill="#DBDEE2"
        d="M37.3 78.106a23.818 23.818 0 01-6.84-6.418 24.277 24.277 0 018.882-36.09c.938-.441 2.541-1.241 4.673-1.202a9.729 9.729 0 017.727 3.91 9.587 9.587 0 011.912 5.611c0-.063 7.357-23.939-24.06-23.939-13.202 0-24.06 12.53-24.06 23.521a39.143 39.143 0 003.643 16.842 38.496 38.496 0 0047.03 20.183 22.721 22.721 0 01-18.88-2.406l-.027-.012z"
        opacity="0.41"
      />
      <path
        fill="#A2AAB3"
        d="M51.315 50.27c-.244.315-.993.751-.993 1.701 0 .785.512 1.54 1.42 2.175 4.325 3.007 12.478 2.61 12.499 2.61a17.913 17.913 0 009.103-2.51 18.46 18.46 0 009.152-15.904c.079-6.74-2.406-11.221-3.41-13.206C72.713 12.67 58.956 5.5 43.998 5.5A38.495 38.495 0 005.502 43.454C5.646 32.465 16.57 23.59 29.562 23.59c1.052 0 7.055.102 12.631 3.029 4.914 2.58 7.489 5.696 9.278 8.784 1.859 3.21 2.19 7.263 2.19 8.878 0 1.615-.824 4.01-2.346 5.988z"
      />
    </svg>
  );
}
